export default __webpack_public_path__ + "locales/sl/ChangePortalOwner.json?hash=ddb0b31ae4ed439ffe3759f2c852c0f3";